﻿
cb.define([], function() {
	var AA_aa_productlist_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {

			//viewmodel.get("btnAddProduct").setVisible(false);

      debugger
      var self = this;
      self.formatter(viewmodel);
        viewmodel.getGridModel().on('afterSetColumns', function () {
          self.formatter(viewmodel);
		});
		

		let gridModel = viewmodel.getGridModel();
		gridModel.on('afterSetDataSource', () => {
  
		  const rows = gridModel.getRows();
		  const actions = gridModel.getCache('actions');
		  const actionsStates = [];
		  rows.forEach(data => {
			// debugger
			const actionState = { };
			actions.forEach(action => {
			  actionState["btnDelete"] = { visible: false };
			  });
			actionsStates.push(actionState);
		  });
		  gridModel.setActionsState(actionsStates);
		});

			//商品标签字段所在的隐藏的viewmodel
			var tagReferModel = new cb.models.ReferModel({
				cRefType: 'aa_tagref',
				multiple: 'true'
			});
			viewmodel.addProperty('tag', tagReferModel);
			tagReferModel.setVisible(false)
			
			//加入商品标签的批量操作
			viewmodel.on('addtag', function(args) {
				tagReferModel.setCache('args', args);
				tagReferModel.browse(true);
			});
			//设置商品标签之前判断是否选择商品
			tagReferModel.on('beforeBrowse', function(data) {
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				if(selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择商品！', 'warning');
					return false;
				}
			});
			tagReferModel.on('afterValueChange', function(data) {
				debugger
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
			//	var selectedTagId = data.value.id;
				var selectedTagId = "";
				var length = data.value.length;
				for(var i = 0; i < length; i++) {
					selectedTagId=selectedTagId+data.value[i].id+",";
				}
				var url = '/mall/bill/batchDo?action=addtag';
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: url,
						method: 'POST'
					}
				});
				var datas = [];
				if(selectedTagId == undefined || selectedTagId.length == 0) {
					cb.utils.alert('未选择商品标签！', 'warning');
				} else {
					var length = selectedRows.length;
					for(var i = 0; i < length; i++) {

						datas.push({
							"product": selectedRows[i]["sku"],
							"tag": selectedTagId,
						});
					}
					var params = {
						billnum: "aa_productlist",
						data: JSON.stringify(datas)
					}
					proxy.ensure(params, function(err, result) {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}
						cb.utils.alert('操作成功', 'success');
						viewmodel.execute('refresh');
					});
				}
			});
    },
    formatter: function (viewmodel) {
      var gridModel = viewmodel.getGridModel();
      gridModel.setColumnState('product_name', 'formatter', function (rowInfo, rowData) {
        var tagName = gridModel.getCellValue(rowInfo.rowIndex, 'tagName');
        if (tagName)
          return { html: '<span class="red-circle m-l-10">'+tagName+'</span>', text: tagName };
      });
    }
	}
	try {
		module.exports = AA_aa_productlist_VM_Extend;
	} catch(error) {

	}
	return AA_aa_productlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_productlist_VM.Extend.js